import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_FAMILIARES = 'ALL_FAMILIARES';
export const LOADING_ALL_FAMILIARES = 'LOADING_ALL_FAMILIARES';
export const ACTIVO_FAMILIARES = 'ACTIVO_FAMILIARES';
export const PARAMS_FAMILIARES = 'PARAMS_FAMILIARES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 50,
    totalItems: 1,
    totalPages: 1,
  },
};

export const familiaresReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_FAMILIARES:
      return {
        ...state,
        all: action.payload.data,
        pagination: action.payload.meta,
      };
    case ACTIVO_FAMILIARES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_FAMILIARES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_FAMILIARES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
